export default __webpack_public_path__ + "static/media/it900-a031.64596d88.jpg";